module.exports = require("live/components/forms/ui/custom-react-datepicker-input");